import { useEffect, useState } from "react";
import { useCourse } from "@/shared/lib";
import { Button } from "@/shared/ui/button";

const STORAGE_PREFIX = "cookie-consent-accepted";

const storageKey = (slug?: string) =>
  slug ? `${STORAGE_PREFIX}:${slug}` : STORAGE_PREFIX;

/**
 * Нижняя плашка-уведомление об использовании cookie.
 *
 * Показывается только если у курса включён `show_cookies` и пользователь
 * ещё не нажимал «Принимаю» (флаг хранится в localStorage). После клика
 * плашка скрывается навсегда для этого курса.
 */
export const CookieBanner = () => {
  const course = useCourse();
  const [accepted, setAccepted] = useState(true);

  useEffect(() => {
    if (typeof window === "undefined") return;
    try {
      setAccepted(!!localStorage.getItem(storageKey(course?.slug)));
    } catch {
      setAccepted(false);
    }
  }, [course?.slug]);

  if (!course?.show_cookies || accepted) return null;

  const accept = () => {
    try {
      localStorage.setItem(storageKey(course?.slug), "1");
    } catch {
      // localStorage недоступен — просто скрываем плашку на эту сессию
    }
    setAccepted(true);
  };

  return (
    <div className="fixed inset-x-0 bottom-0 z-50 border-t border-gray-200 bg-white/95 shadow-lg backdrop-blur">
      <div className="mx-auto flex max-w-5xl flex-col items-start gap-3 px-4 py-4 sm:flex-row sm:items-center sm:justify-between">
        <p className="text-body-sm leading-relaxed text-gray-700">
          Мы используем файлы cookie для обеспечения работы сайта и анализа
          посещаемости. Продолжая пользоваться сайтом, вы соглашаетесь с
          использованием файлов cookie.
        </p>
        <Button
          variant="primary"
          onClick={accept}
          className="shrink-0 whitespace-nowrap"
        >
          Принимаю
        </Button>
      </div>
    </div>
  );
};
